import AppConfig from "./services/appConfig";
import LanguageSwitcher from "./components/LanguageSwitcher/LanguageSwitcher";

import "./App.css";

function App() {
  if ("object" === typeof AppConfig()) {
    return (
      <div className="wpglobus-widgets-app">
        <LanguageSwitcher />
      </div>
    );
  } else {
    return <div className="wpglobus-widgets-app">No config!</div>;
  }
}

export default App;
